module.exports = __webpack_public_path__ + "static/media/graph.0af6d1d0.svg";